import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import {
  BroadcastAuthenticatedNotificationStatus,
  BroadcastCacheUpdateSelectedMerchant,
  BroadcastCacheUpdateUserProfile,
  BroadcastDisconnectNotificationAllTab,
} from "@/broadcastChannel/userChannel";
import { AuthenticatedNotification, CacheType } from "@/enums/enums";
import {
  RemoveSocketSessionIdFromCookies,
  SetSocketSessionIdFromCookies,
  SocketAuthentication,
} from "@/helper/notificationHelper";
import { CheckAssetTokenValid } from "@/helper/routerHelper";
import { IsMasterTabAvailable } from "@/helper/tabHelper";
import { MerchantId } from "@/helper/userHelper";
import { CheckIndexedDBIsSupport } from "@/IndexedDB/tabIndexedDB";
import store from "@/store/index";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Notification extends VuexModule {
  public notificationIsConnect = false;
  public notificationReadyToUse = false;
  public notificationIsAuthenticated = false;

  get getNotificationIsConnect(): boolean {
    return this.notificationIsConnect;
  }

  get getNotificationReadyToUse(): boolean {
    return this.notificationReadyToUse;
  }

  get getNotificationIsAuthenticated(): boolean {
    return this.notificationIsAuthenticated;
  }

  @Mutation
  public SOCKET_authenticated(payload: any) {
    if (payload) {
      this.notificationIsAuthenticated = true;
      this.notificationReadyToUse = true;
      SetSocketSessionIdFromCookies();
      BroadcastAuthenticatedNotificationStatus(AuthenticatedNotification.Success);
      BroadcastDisconnectNotificationAllTab();
    } else {
      this.notificationReadyToUse = false;
      RemoveSocketSessionIdFromCookies();
      BroadcastAuthenticatedNotificationStatus(AuthenticatedNotification.Failed);
    }
  }

  @Mutation
  public SOCKET_connect() {
    this.notificationIsConnect = true;
    SocketAuthentication();
  }

  @Mutation
  public SOCKET_disconnect() {
    this.notificationIsConnect = false;
    this.notificationIsAuthenticated = false;
    if (!IsMasterTabAvailable()) {
      this.notificationReadyToUse = false;
    }
  }

  @Mutation
  public async SOCKET_ResetCache(payload: { cacheTypeList: CacheType[] }) {
    await CheckAssetTokenValid();
    const merchantId = MerchantId();
    if (payload.cacheTypeList && payload.cacheTypeList.length > 0) {
      for (const cacheType of payload.cacheTypeList) {
        switch (cacheType) {
          case CacheType.UserProfile:
            await store.dispatch("LogIn/DoGetUserInfoByResetCache");
            setTimeout(() => {
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                BroadcastCacheUpdateUserProfile();
              }
            }, 0);
            break;
          case CacheType.SelectedMerchant:
            if (merchantId) {
              store.commit("LogIn/MutationReSetMerchantModelList");

              await store.dispatch("LogIn/DoGetMerchantByResetCache", {
                merchantId: merchantId,
                isUseMainDatabase: true,
              });

              setTimeout(() => {
                if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                  BroadcastCacheUpdateSelectedMerchant();
                }
              }, 0);
            }
            break;
        }
      }
    }
  }

  @Mutation
  public MutationSetNotificationReadyToUse(status: boolean) {
    this.notificationReadyToUse = status;
  }
}
